import { RouteConfig } from '../types';
import * as Components from '../lazyComponents';

export const publicRoutes: RouteConfig[] = [
  {
    // #875 — el cliente de la agencia paga aca. Sin login, sin layout: no es un
    // usuario de InboMarket, es el comprador de una propiedad.
    path: '/pagar/:code',
    element: <Components.PublicPayPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  {
    // #874 — booking público estilo Calendly. Sin login ni layout: quien entra es
    // un prospecto que agenda solo. Resuelve /public/book/:tenantSlug/:calendarSlug.
    path: '/book/:tenantSlug/:calendarSlug',
    element: <Components.PublicBookingPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  {
    path: '/',
    element: <Components.RootRedirect />,
    requiresAuth: false,
    requiresLayout: false,
  },
  {
    path: '/properties',
    element: <Components.PublicPropertiesPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  {
    path: '/properties/:slug',
    element: <Components.PropertyDetailPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  {
    path: '/contact',
    element: <Components.ContactPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  // Task #664 — Public plans catalog (pricing landing)
  {
    path: '/pricing',
    element: <Components.PlansCatalogPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  // Task #665 — Signup wizard 4-step (country detect + currency + trial 14d)
  {
    path: '/signup',
    element: <Components.SignupPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  // GH#1826 — aceptación de invitación de agente. El token del correo es la auth;
  // sin login ni layout. Público, resuelve /aceptar-invitacion?token=...
  {
    path: '/aceptar-invitacion',
    element: <Components.AcceptInvitationPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  // GH#1797 (a) — a esta página manda Meta a quien pidió borrar sus datos (url del callback
  // /webhooks/meta/data-deletion). Sin login ni layout: llega con ?code=<código de confirmación>.
  {
    path: '/borrado-datos',
    element: <Components.MetaDataDeletionStatusPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  // Task #672-2 — Public invite accept page (token-authenticated, no JWT needed).
  // Anonymous users get redirected to /signup?inviteToken=... so the signup
  // wizard (#665) can pre-fill the invite linkage and accept post-creation.
  {
    path: '/network/invite/accept/:token',
    element: <Components.NetworkInviteAcceptPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  // Task #673 — Public consolidated franchise landing (custom domain CNAME +
  // SSL + cross-tenant property/branch/agent aggregation). Accessible via
  // /n/:slug en SPA, o via custom_domain con DNS CNAME → edge proxy.
  {
    path: '/n/:slug',
    element: <Components.NetworkLandingPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  // #710 PB0-CAT4-55 — MetaBroker IA floating widget preview (marketplace
  // bubble embed), «V1 Mock … usado por QA». #23466: ya NO es pública. Esta página llama a
  // `POST /public/ia/marketplace/query`, que no es un flujo de cliente; pide sesión (sin rol:
  // no hay un rol «QA»). Sin sesión, AuthGuard manda al login.
  {
    path: '/metabroker/floating-widget',
    element: <Components.MetaBrokerFloatingWidgetPage />,
    requiresAuth: true,
    requiresLayout: false,
  },
  // Mortgage — public calculator widget preview (embeddable en property pages).
  // Public, no auth — wraps MortgageCalculator + captura de lead.
  {
    path: '/mortgage/calculator',
    element: <Components.MortgageCalculatorWidgetPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
];
